export default __webpack_public_path__ + "static/media/usdc-killer.559e73d7.png";